<!-- Page Header: a empresa alvo fica sempre visivel -->
<div class="page-header">
  <button pButton icon="pi pi-arrow-left" class="p-button-text p-button-rounded voltar-btn"
    [pTooltip]="texts.voltar" tooltipPosition="bottom" (click)="voltar()"></button>
  <div class="header-icon">
    <i class="pi pi-shield"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ resumo?.empresa?.nome || texts.titulo }}</h1>
    <p class="header-subtitle" *ngIf="resumo?.empresa as empresa">
      {{ empresa.ruc || '-' }} &middot; {{ empresa.email }}
    </p>
  </div>
  <span class="badge-operando" *ngIf="resumo?.empresa as empresa">
    <i class="pi pi-eye"></i> {{ texts.operando_como }}: {{ empresa.nome }}
  </span>
</div>

<div class="page-body tabs-container">
  <div class="loading-box" *ngIf="loading">
    <i class="pi pi-spinner pi-spin"></i>
    <span>{{ texts.carregando }}</span>
  </div>

  <p-tabView *ngIf="!loading && resumo" (onChange)="onTabChange($event)">
    <!-- ================= Configuracao ================= -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-building tab-icon"></i>
        <span>{{ abas.configuracao }}</span>
      </ng-template>
      <div class="info-grid" *ngIf="resumo.empresa as empresa">
        <div class="info-card">
          <span class="info-label">{{ labels.nome }}</span>
          <span class="info-valor">{{ empresa.nome }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.fantasia }}</span>
          <span class="info-valor">{{ empresa.fantasia || '-' }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.ruc }}</span>
          <span class="info-valor">{{ empresa.ruc || '-' }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.email }}</span>
          <span class="info-valor">{{ empresa.email }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.telefone }}</span>
          <span class="info-valor">{{ (empresa | formatPhone) || '-' }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.cidade }}</span>
          <span class="info-valor">{{ empresa.cidade || '-' }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.moeda }}</span>
          <span class="info-valor">{{ empresa.moeda || '-' }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.cliente_desde }}</span>
          <span class="info-valor">{{ (empresa.criadoEm | date: 'dd/MM/yyyy') || '-' }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.contador }}</span>
          <span class="info-valor">{{ simNao(empresa.contador) }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.primeiros_passos }}</span>
          <span class="info-valor">{{ simNao(empresa.concluiuOsPrimeirosPassos) }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.minishop }}</span>
          <span class="info-valor">{{ simNao(empresa.habilitarMiniShopping) }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.cobranca_qrcode }}</span>
          <span class="info-valor">{{ simNao(empresa.bancardConfigurado) }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.cobranca_cartao }}</span>
          <span class="info-valor">{{ simNao(empresa.tpagoConfigurado) }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.nota_eletronica }}</span>
          <span class="info-valor">{{ simNao(empresa.estadoAutorizacaoNotaEletronica) }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.certificado }}</span>
          <span class="info-valor">{{ empresa.nomeCertificadoDigital || '-' }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.certificado_vence }}</span>
          <span class="info-valor">
            {{ (empresa.vencimentoCertificadoDigital | date: 'dd/MM/yyyy') || '-' }}
          </span>
        </div>
      </div>
    </p-tabPanel>

    <!-- ================= Assinatura ================= -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-star tab-icon"></i>
        <span>{{ abas.assinatura }}</span>
      </ng-template>
      <div class="sem-assinatura" *ngIf="!resumo.inscricao">
        <i class="pi pi-info-circle"></i>
        <span>{{ texts.sem_assinatura }}</span>
      </div>

      <!-- Seletor de periodo: so aparece quando ha ciclo anterior para conferir -->
      <div class="periodo-seletor" *ngIf="ciclosOptions.length > 1">
        <label class="periodo-label">{{ labels.periodo }}</label>
        <p-dropdown [options]="ciclosOptions" optionLabel="label" optionValue="value"
          [(ngModel)]="cicloSelecionadoInicio" [showClear]="false"
          appendTo="body" styleClass="periodo-dropdown"
          [placeholder]="labels.ciclo_atual">
        </p-dropdown>
        <button *ngIf="visaoHistorica" pButton type="button"
          icon="pi pi-replay" class="p-button-text btn-sm"
          [label]="texts.voltar_ao_atual"
          (click)="voltarAoCicloAtual()">
        </button>
      </div>

      <!-- Deixa explicito que os cards abaixo nao sao o presente -->
      <div class="aviso-historico" *ngIf="visaoHistorica">
        <i class="pi pi-history"></i>
        <span>{{ texts.visao_historica }}</span>
      </div>

      <div class="info-grid" *ngIf="inscricaoExibida as inscricao">
        <div class="info-card">
          <span class="info-label">{{ labels.plano }}</span>
          <span class="info-valor">{{ inscricao.planoNome || '-' }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ visaoHistorica ? labels.situacao_no_periodo : labels.situacao }}</span>
          <span class="info-valor">{{ situacaoDaAssinatura }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.contratado_em }}</span>
          <span class="info-valor">{{ (inscricao.dataDeInscricao | date: 'dd/MM/yyyy') || '-' }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.vence_em }}</span>
          <span class="info-valor">
            {{ inscricao.especial ? labels.nunca_vence : ((inscricao.dataDeVencimento | date: 'dd/MM/yyyy') || '-') }}
          </span>
        </div>
        <!-- Meses restantes é conta do presente: num ciclo fechado não significa nada -->
        <div class="info-card" *ngIf="!visaoHistorica">
          <span class="info-label">{{ labels.meses_restantes }}</span>
          <span class="info-valor">{{ inscricao.mesesRestantes }}</span>
        </div>
        <!-- No histórico, os acessos daquele período entram no lugar -->
        <div class="info-card" *ngIf="visaoHistorica">
          <span class="info-label">{{ labels.acessos_no_periodo }}</span>
          <span class="info-valor">{{ inscricao.limiteDeUsuarios }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.valor }}</span>
          <span class="info-valor">{{ (inscricao.valorDeCobranca ?? null) | guaraniFormat }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.forma_pagamento }}</span>
          <span class="info-valor">{{ inscricao.tipoPagamento || '-' }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.periodicidade }}</span>
          <span class="info-valor">{{ periodicidadeDoPlano }}</span>
        </div>
        <div class="info-card">
          <span class="info-label">{{ labels.valor_do_plano }}</span>
          <span class="info-valor">{{ (inscricao.valorPlano ?? null) | guaraniFormat }}</span>
        </div>
        <!-- Desconto so aparece quando existe: campo zerado em toda ficha e ruido -->
        <div class="info-card" *ngIf="temDesconto">
          <span class="info-label">{{ labels.desconto }}</span>
          <span class="info-valor">{{ inscricao.porcentagemDesconto }}%</span>
        </div>
      </div>

      <!-- Limite de vendas: a resposta para "por que nao consigo mais vender?" -->
      <div class="acessos-card" *ngIf="limiteDeVendasExibido as vendas">
        <div class="acessos-titulo">
          <i class="pi pi-chart-line"></i>
          <span>{{ labels.limite_de_vendas }}</span>
          <span class="tag-negociado" *ngIf="vendas.negociado">{{ labels.negociado }}</span>
        </div>

        <div class="acessos-grid">
          <div class="acesso-item acesso-item--destaque">
            <span class="acesso-numero acesso-numero--valor">
              {{ vendas.semLimite ? labels.sem_limite : (vendas.limiteAplicado | guaraniFormat) }}
            </span>
            <span class="acesso-label">{{ labels.limite_mensal }}</span>
          </div>
          <div class="acesso-item">
            <span class="acesso-numero acesso-numero--valor">{{ vendas.vendasNoCiclo | guaraniFormat }}</span>
            <span class="acesso-label">{{ labels.vendido_no_ciclo }}</span>
          </div>
          <div class="acesso-item">
            <span class="acesso-numero acesso-numero--valor">
              {{ vendas.semLimite ? labels.sem_limite : (vendas.disponivel | guaraniFormat) }}
            </span>
            <span class="acesso-label">{{ labels.disponivel_para_vender }}</span>
          </div>
        </div>

        <!-- Barra so faz sentido quando ha teto: sem limite ela ficaria sempre vazia -->
        <div class="uso-do-limite" *ngIf="!vendas.semLimite">
          <div class="uso-do-limite-topo">
            <span>{{ labels.uso_do_limite }}</span>
            <span class="uso-do-limite-percentual" [class.uso-estourado]="vendas.percentualUsado >= 100">
              {{ vendas.percentualUsado }}%
            </span>
          </div>
          <p-progressBar [value]="vendas.percentualUsado" [showValue]="false"
            [styleClass]="vendas.percentualUsado >= 100 ? 'limite-bar limite-bar--estourado' : 'limite-bar'">
          </p-progressBar>
        </div>

        <div class="ciclo-info">
          <span>{{ rotuloDoPeriodoExibido }}: {{ periodoExibido }}</span>
          <span>{{ textoDoLimiteAplicado }}</span>
        </div>
      </div>

      <!-- Concessoes do suporte: valem na hora, sem cobranca -->
      <div class="acoes-assinatura">
        <button pButton icon="pi pi-star" class="p-button-outlined"
          [label]="concessaoTexts.conceder_plano" (click)="abrirDialogPlano()"></button>
        <button pButton icon="pi pi-user-plus" class="p-button-outlined"
          [label]="concessaoTexts.conceder_vagas" (click)="abrirDialogVagas()"
          [disabled]="!resumo.inscricao"></button>
        <button pButton icon="pi pi-star-fill" class="p-button-outlined"
          [label]="especialTexts.abrir" (click)="abrirDialogPlanoEspecial()"></button>
        <span class="acoes-ajuda">{{ concessaoTexts.sem_cobranca }}</span>
      </div>

      <!-- Cobrancas: o cliente paga, a mudanca vale na confirmacao da Bancard -->
      <div class="acoes-assinatura">
        <button pButton icon="pi pi-qrcode" class="p-button-outlined p-button-secondary"
          [label]="cobrancaTexts.cobrar_plano" (click)="abrirDialogCobranca('PLANO')"></button>
        <button pButton icon="pi pi-credit-card" class="p-button-outlined p-button-secondary"
          [label]="cobrancaTexts.cobrar_vagas" (click)="abrirDialogCobranca('VAGAS')"
          [disabled]="!resumo.limiteDeUsuarios.podeContratarUsuarios"></button>
        <span class="acoes-ajuda">{{ cobrancaTexts.explicacao }}</span>
      </div>

      <!-- Acessos: a conta que explica o limite do cliente -->
      <div class="acessos-card" *ngIf="acessosExibidos as limite">
        <div class="acessos-titulo">
          <i class="pi pi-users"></i>
          <span>{{ labels.acessos }}</span>
        </div>
        <div class="acessos-grid">
          <div class="acesso-item">
            <span class="acesso-numero">{{ limite.usuariosInclusos }}</span>
            <span class="acesso-label">{{ labels.inclusos }}</span>
          </div>
          <div class="acesso-item">
            <span class="acesso-numero">{{ limite.usuariosExtras }}</span>
            <span class="acesso-label">{{ labels.comprados }}</span>
          </div>
          <div class="acesso-item">
            <span class="acesso-numero">{{ limite.usuariosCortesia }}</span>
            <span class="acesso-label">{{ labels.concedidos }}</span>
          </div>
          <div class="acesso-item acesso-item--destaque">
            <span class="acesso-numero">{{ limite.limite }}</span>
            <span class="acesso-label">{{ labels.limite }}</span>
          </div>
          <!-- Quantos acessos estavam em uso num mês passado não existe no banco: só o de hoje -->
          <div class="acesso-item" *ngIf="!visaoHistorica">
            <span class="acesso-numero">{{ limite.usuariosAtivos }}</span>
            <span class="acesso-label">{{ labels.em_uso }}</span>
          </div>
          <div class="acesso-item" *ngIf="!visaoHistorica">
            <span class="acesso-numero">{{ limite.vagasDisponiveis }}</span>
            <span class="acesso-label">{{ labels.disponiveis }}</span>
          </div>
        </div>
      </div>

      <!-- =============== Historico por ciclo =============== -->
      <!-- Serve a conferencia mes a mes: o seletor acima investiga um ciclo; a tabela
           compara varios de uma vez, sem trocar a selecao a cada pergunta. -->
      <div class="table-card historico-ciclos" *ngIf="ciclosLoading || ciclos.length > 0">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-history"></i>
          </div>
          <span class="card-header-title">{{ texts.historico_titulo }}</span>
        </div>

        <div class="card-content">
          <small class="historico-ajuda">{{ texts.historico_ajuda }}</small>

          <p-table [value]="ciclos" [loading]="ciclosLoading"
            dataKey="inicio" [tableStyle]="{ 'width': '100%' }"
            styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 20%">{{ labels.periodo }}</th>
                <th style="width: 16%">{{ labels.plano }}</th>
                <th style="width: 13%">{{ labels.col_cobranca }}</th>
                <th style="width: 14%">{{ labels.limite_mensal }}</th>
                <th style="width: 14%">{{ labels.col_vendido }}</th>
                <th style="width: 9%">{{ labels.col_uso }}</th>
                <th style="width: 14%">{{ labels.acessos }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-ciclo>
              <tr [class.ciclo-atual]="ciclo.atual">
                <td>
                  <span>{{ rotuloDoCiclo(ciclo) }}</span>
                </td>
                <td>
                  <span>{{ ciclo.planoNome || '-' }}</span>
                  <!-- Sem vigencia: naquele ciclo valia o teto do plano gratuito -->
                  <small class="ciclo-sem-vigencia" *ngIf="!ciclo.assinaturaVigente && !ciclo.especial">
                    {{ labels.sem_vigencia }}
                  </small>
                </td>
                <td>
                  <!-- O valor aparece uma vez so, no ciclo em que a cobranca aconteceu: num plano
                       anual, repeti-lo em todos leria como doze pagamentos. -->
                  <span *ngIf="ciclo.primeiroCicloDaAssinatura">{{ ciclo.valorDeCobranca ?? null | guaraniFormat }}</span>
                  <span *ngIf="!ciclo.primeiroCicloDaAssinatura" class="ciclo-sem-cobranca">—</span>
                </td>
                <td>{{ ciclo.semLimite ? labels.sem_limite : (ciclo.limiteAplicado | guaraniFormat) }}</td>
                <td>{{ ciclo.vendasNoPeriodo | guaraniFormat }}</td>
                <td>
                  <span *ngIf="!ciclo.semLimite" [class.uso-estourado]="ciclo.percentualUsado >= 100">
                    {{ ciclo.percentualUsado }}%
                  </span>
                  <span *ngIf="ciclo.semLimite">—</span>
                </td>
                <td>{{ ciclo.limiteDeUsuarios }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7" class="text-center p-4">
                  {{ texts.historico_vazio }}
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td colspan="7" class="text-center p-4">
                  <i class="pi pi-spinner pi-spin"></i>
                  <span class="ml-2">{{ texts.historico_carregando }}</span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>
    <!-- ================= Usuarios ================= -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-users tab-icon"></i>
        <span>{{ abas.usuarios }}</span>
      </ng-template>

      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-users"></i>
          </div>
          <span class="card-header-title">{{ usuariosTexts.titulo }}</span>
        </div>

        <div class="card-content">
          <div class="search-bar">
            <app-column-selector
              [columns]="colunasUsuarios"
              [storageKey]="STORAGE_KEY_USUARIOS"
              (columnsChange)="onColunasChange($event)">
            </app-column-selector>
          </div>

          <p-table [value]="usuarios" [loading]="usuariosLoading"
            (onSort)="onSortUsuarios($any($event))"
            [sortField]="usuariosLastfield" [sortOrder]="usuariosLastSort === 'asc' ? 1 : -1"
            [tableStyle]="{ 'width': '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColunaVisivel('nome')" style="width: 30%">{{ labels.usuario }}</th>
                <th [hidden]="!isColunaVisivel('email')" pSortableColumn="email" style="width: 30%">
                  {{ labels.email_usuario }}<p-sortIcon [field]="'email'"></p-sortIcon>
                </th>
                <th [hidden]="!isColunaVisivel('situacao')" pSortableColumn="ativo" style="width: 12%">
                  {{ labels.status }}<p-sortIcon [field]="'ativo'"></p-sortIcon>
                </th>
                <th [hidden]="!isColunaVisivel('criadoEm')" pSortableColumn="criadoEm" style="width: 14%">
                  {{ labels.data_inclusao }}<p-sortIcon [field]="'criadoEm'"></p-sortIcon>
                </th>
                <th [hidden]="!isColunaVisivel('acoes')" style="width: 14%">{{ labels.acoes }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-usuario>
              <tr>
                <td [hidden]="!isColunaVisivel('nome')">{{ usuario.pessoa?.nome || usuario.username }}</td>
                <td [hidden]="!isColunaVisivel('email')">{{ usuario.email }}</td>
                <td [hidden]="!isColunaVisivel('situacao')">
                  <span class="status-badge" [class.status-badge--ativo]="usuario.ativo">
                    {{ usuario.ativo ? labels.ativo : labels.inativo }}
                  </span>
                </td>
                <td [hidden]="!isColunaVisivel('criadoEm')">
                  <div class="date-cell">
                    <i class="pi pi-calendar"></i>
                    {{ usuario.criadoEm | date: 'dd/MM/yyyy' }}
                  </div>
                </td>
                <td [hidden]="!isColunaVisivel('acoes')" class="actions">
                  <button pButton icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-sm action-btn edit-btn"
                    [pTooltip]="usuariosTexts.editar_dados" tooltipPosition="top"
                    (click)="abrirDialogEdicao(usuario)"></button>
                  <button pButton icon="pi pi-key"
                    class="p-button-text p-button-rounded p-button-sm action-btn"
                    [pTooltip]="usuariosTexts.alterar_senha" tooltipPosition="top"
                    (click)="abrirDialogSenha(usuario)"></button>
                  <button pButton
                    [icon]="usuario.ativo ? 'pi pi-ban' : 'pi pi-check-circle'"
                    class="p-button-text p-button-rounded p-button-sm action-btn"
                    [loading]="statusEmProgresso.has(usuario.id)"
                    [pTooltip]="usuario.ativo ? labels.inativo : labels.ativo" tooltipPosition="top"
                    (click)="alternarStatus(usuario)"></button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="colunasVisiveis" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-users text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ usuariosTexts.nenhum }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="colunasVisiveis" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ usuariosTexts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="pagination-container">
            <div>
              <p-paginator (onPageChange)="onUsuariosPageChange($any($event))"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="usuariosFirst" [rows]="usuariosRows"
                [totalRecords]="usuariosTotal" [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown [options]="pageSizeOptions" optionLabel="label"
                optionValue="value" [(ngModel)]="usuariosRows"
                (ngModelChange)="onUsuariosRowsPerPageChange()" styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

    <!-- ================= Sessoes ================= -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-desktop tab-icon"></i>
        <span>{{ abas.sessoes }}</span>
      </ng-template>

      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-desktop"></i>
          </div>
          <span class="card-header-title">{{ sessoesTexts.titulo }}</span>
          <button pButton icon="pi pi-refresh" class="p-button-text p-button-rounded ml-auto"
            [pTooltip]="sessoesTexts.atualizar" tooltipPosition="bottom"
            [loading]="sessoesLoading" (click)="carregarSessoes()"></button>
        </div>

        <div class="card-content">
          <p class="sessoes-explicacao">
            <i class="pi pi-info-circle"></i> {{ sessoesTexts.explicacao }}
          </p>

          <p-table [value]="sessoes" [loading]="sessoesLoading" [tableStyle]="{ 'width': '100%' }">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 24%">{{ sessoesTexts.usuario }}</th>
                <th style="width: 11%">{{ sessoesTexts.plataforma }}</th>
                <th style="width: 12%">{{ sessoesTexts.situacao }}</th>
                <th style="width: 17%">{{ sessoesTexts.aparelho }}</th>
                <th style="width: 12%">{{ sessoesTexts.inicio }}</th>
                <th style="width: 12%">{{ sessoesTexts.ultimo_uso }}</th>
                <th style="width: 12%">{{ sessoesTexts.acoes }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-sessao>
              <tr>
                <td>
                  <div class="sessao-usuario">
                    <span class="sessao-nome">{{ sessao.nome || sessao.username }}</span>
                    <span class="sessao-email">{{ sessao.email }}</span>
                  </div>
                </td>
                <td>
                  <span class="plataforma-badge">
                    <i [class]="sessao.plataforma === 'MOBILE' ? 'pi pi-mobile' : 'pi pi-desktop'"></i>
                    {{ rotuloDaPlataforma(sessao.plataforma) }}
                  </span>
                </td>
                <td>
                  <span class="status-badge" [class.status-badge--ativo]="sessao.viva">
                    {{ sessao.viva ? sessoesTexts.ocupando : sessoesTexts.liberada }}
                  </span>
                </td>
                <td class="sessao-aparelho">{{ sessao.deviceId || sessoesTexts.sem_aparelho }}</td>
                <td>
                  <div class="date-cell">
                    <i class="pi pi-calendar"></i>
                    {{ sessao.criadoEm | date: 'dd/MM/yyyy HH:mm' }}
                  </div>
                </td>
                <td>
                  <div class="date-cell">
                    <i class="pi pi-clock"></i>
                    {{ sessao.ultimoUso | date: 'dd/MM/yyyy HH:mm' }}
                  </div>
                </td>
                <td class="actions">
                  <button pButton icon="pi pi-sign-out"
                    class="p-button-text p-button-rounded p-button-sm action-btn p-button-danger"
                    [loading]="sessoesEmProgresso.has(sessao.id)"
                    [pTooltip]="sessoesTexts.encerrar" tooltipPosition="top"
                    (click)="encerrarSessao(sessao)"></button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-desktop text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ sessoesTexts.nenhuma }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td colspan="7" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ sessoesTexts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<p-toast></p-toast>
<p-confirmDialog [style]="{ width: '28rem' }"></p-confirmDialog>

<!-- Dialogo: nova senha -->
<p-dialog [(visible)]="senhaDialogVisible" [modal]="true" [draggable]="false"
  [header]="usuariosTexts.alterar_senha" [style]="{ width: '28rem' }">
  <div class="dialog-conteudo">
    <p class="dialog-aviso">{{ usuariosTexts.senha_aviso }}</p>
    <p class="dialog-alvo" *ngIf="usuarioDaSenha">
      {{ usuarioDaSenha.pessoa?.nome || usuarioDaSenha.username }} &middot; {{ usuarioDaSenha.email }}
    </p>

    <div class="field">
      <label>{{ labels.nova_senha }}</label>
      <p-password [(ngModel)]="senhaNova" [feedback]="false" [toggleMask]="true"
        styleClass="w-full" inputStyleClass="w-full"></p-password>
      <small class="p-error" *ngIf="senhaSubmetida && senhaNova.length < 8">
        {{ 'master.usuarios.mensagens.senha_minima' | translate }}
      </small>
    </div>

    <div class="field">
      <label>{{ labels.confirmar_senha }}</label>
      <p-password [(ngModel)]="senhaConfirmacao" [feedback]="false" [toggleMask]="true"
        styleClass="w-full" inputStyleClass="w-full"></p-password>
      <small class="p-error" *ngIf="senhaSubmetida && senhaNova !== senhaConfirmacao">
        {{ 'master.usuarios.mensagens.senhas_diferentes' | translate }}
      </small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" [label]="usuariosTexts.cancelar"
      [disabled]="salvandoSenha" (click)="senhaDialogVisible = false"></button>
    <button pButton icon="pi pi-check" [label]="usuariosTexts.salvar"
      [loading]="salvandoSenha" (click)="salvarSenha()"></button>
  </ng-template>
</p-dialog>

<!-- Dialogo: dados do usuario -->
<p-dialog [(visible)]="edicaoDialogVisible" [modal]="true" [draggable]="false"
  [header]="usuariosTexts.editar_dados" [style]="{ width: '30rem' }">
  <div class="dialog-conteudo">
    <div class="field">
      <label>{{ labels.nome_usuario }}</label>
      <input pInputText class="w-full" [(ngModel)]="formUsuario.nome" />
      <small class="p-error" *ngIf="edicaoSubmetida && !formUsuario.nome.trim()">
        {{ 'common.campo_obrigatorio' | translate }}
      </small>
    </div>

    <div class="field">
      <label>{{ labels.email_usuario }}</label>
      <input pInputText class="w-full" [(ngModel)]="formUsuario.email" />
      <small class="p-error" *ngIf="edicaoSubmetida && !formUsuario.email.trim()">
        {{ 'common.campo_obrigatorio' | translate }}
      </small>
    </div>

    <div class="field">
      <label>{{ labels.telefone_usuario }}</label>
      <input pInputText class="w-full" [(ngModel)]="formUsuario.telefone" />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" [label]="usuariosTexts.cancelar"
      [disabled]="salvandoUsuario" (click)="edicaoDialogVisible = false"></button>
    <button pButton icon="pi pi-check" [label]="usuariosTexts.salvar"
      [loading]="salvandoUsuario" (click)="salvarDadosDoUsuario()"></button>
  </ng-template>
</p-dialog>

<!-- Dialogo: conceder plano (sem cobranca) -->
<p-dialog [(visible)]="planoDialogVisible" [modal]="true" [draggable]="false"
  [header]="concessaoTexts.conceder_plano" [style]="{ width: '32rem' }">
  <div class="dialog-conteudo">
    <p class="dialog-alvo" *ngIf="resumo?.empresa as empresa">
      {{ concessaoTexts.alvo }}: {{ empresa.nome }}
    </p>
    <p class="dialog-aviso">{{ concessaoTexts.sem_cobranca }}</p>

    <div class="field">
      <label>{{ concessaoTexts.plano }}</label>
      <p-dropdown [options]="planos" optionLabel="nome" optionValue="id"
        [(ngModel)]="planoSelecionadoId" [loading]="planosCarregando"
        [filter]="true" filterBy="nome" appendTo="body" styleClass="w-full">
      </p-dropdown>
      <small class="p-error" *ngIf="planoSubmetido && !planoSelecionadoId">
        {{ 'common.campo_obrigatorio' | translate }}
      </small>
    </div>

    <div class="field">
      <label>{{ concessaoTexts.total_acessos }}</label>
      <p-inputNumber [(ngModel)]="planoUsuariosPermitidos" [min]="minimoDeAcessos" [max]="100"
        [showButtons]="true" styleClass="w-full" inputStyleClass="w-full"></p-inputNumber>
      <small class="campo-ajuda">{{ concessaoTexts.total_acessos_ajuda }}</small>
    </div>

    <!-- Vagas pagas so aparecem quando existem: e a decisao que nao pode passar despercebida. -->
    <div class="field" *ngIf="vagasPagas > 0">
      <div class="flex align-items-center gap-2">
        <p-checkbox [(ngModel)]="planoManterUsuariosPagos" [binary]="true"
          inputId="manterPagos"></p-checkbox>
        <label for="manterPagos" class="mb-0">
          {{ concessaoTexts.manter_pagos }} ({{ vagasPagas }})
        </label>
      </div>
      <small class="campo-ajuda">{{ concessaoTexts.manter_pagos_ajuda }}</small>
    </div>

    <div class="field">
      <label>{{ concessaoTexts.motivo }}</label>
      <input pInputText class="w-full" [(ngModel)]="planoMotivo" maxlength="255" />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" [label]="concessaoTexts.cancelar"
      [disabled]="salvandoPlano" (click)="planoDialogVisible = false"></button>
    <button pButton icon="pi pi-check" [label]="concessaoTexts.salvar"
      [loading]="salvandoPlano" (click)="concederPlano()"></button>
  </ng-template>
</p-dialog>

<!-- Dialogo: conceder vagas (sem cobranca, mantendo o plano) -->
<!-- Dialogo: plano especial negociado (faixa, valor, prazo e limite proprios) -->
<p-dialog [(visible)]="especialDialogVisible" [modal]="true" [draggable]="false"
  [header]="especialTexts.titulo" [style]="{ width: '34rem', 'max-height': '95vh' }"
  [contentStyle]="{ 'max-height': '70vh', 'overflow-y': 'auto' }">
  <div class="dialog-conteudo">
    <p class="dialog-alvo" *ngIf="resumo?.empresa as empresa">
      {{ concessaoTexts.alvo }}: {{ empresa.nome }}
    </p>
    <p class="dialog-aviso">{{ especialTexts.explicacao }}</p>

    <div class="field">
      <label>{{ especialTexts.categoria }}</label>
      <p-dropdown [options]="categoriasEspeciais" optionLabel="label" optionValue="value"
        [(ngModel)]="especialCategoria" appendTo="body" styleClass="w-full">
      </p-dropdown>
    </div>

    <div class="field">
      <label>{{ especialTexts.valor }}</label>
      <p-inputNumber [(ngModel)]="especialValor" [min]="0" mode="decimal"
        [useGrouping]="true" styleClass="w-full" inputStyleClass="w-full"></p-inputNumber>
      <small class="campo-ajuda">{{ especialTexts.valor_ajuda }}</small>
      <small class="p-error" *ngIf="especialSubmetido && especialValor === null">
        {{ 'common.campo_obrigatorio' | translate }}
      </small>
    </div>

    <div class="field">
      <label>{{ especialTexts.periodo }}</label>
      <p-inputNumber [(ngModel)]="especialPeriodoDias" [min]="1" [max]="3650"
        [showButtons]="true" styleClass="w-full" inputStyleClass="w-full"></p-inputNumber>
      <small class="campo-ajuda">{{ especialTexts.periodo_ajuda }}</small>
      <small class="p-error" *ngIf="especialSubmetido && !especialPeriodoDias">
        {{ 'common.campo_obrigatorio' | translate }}
      </small>
    </div>

    <div class="field">
      <label>{{ especialTexts.limite }}</label>
      <p-inputNumber [(ngModel)]="especialLimiteDeVendas" [min]="0" mode="decimal"
        [useGrouping]="true" styleClass="w-full" inputStyleClass="w-full"></p-inputNumber>
      <small class="campo-ajuda">{{ especialTexts.limite_ajuda }}</small>
      <small class="p-error" *ngIf="especialSubmetido && especialLimiteDeVendas === null">
        {{ 'common.campo_obrigatorio' | translate }}
      </small>
    </div>

    <div class="field">
      <label>{{ concessaoTexts.total_acessos }}</label>
      <p-inputNumber [(ngModel)]="especialUsuariosPermitidos" [min]="1" [max]="100"
        [showButtons]="true" styleClass="w-full" inputStyleClass="w-full"></p-inputNumber>
      <small class="campo-ajuda">{{ concessaoTexts.total_acessos_ajuda }}</small>
    </div>

    <!-- Vagas pagas so aparecem quando existem: e a decisao que nao pode passar despercebida. -->
    <div class="field" *ngIf="vagasPagas > 0">
      <div class="flex align-items-center gap-2">
        <p-checkbox [(ngModel)]="especialManterUsuariosPagos" [binary]="true"
          inputId="manterPagosEspecial"></p-checkbox>
        <label for="manterPagosEspecial" class="mb-0">
          {{ concessaoTexts.manter_pagos }} ({{ vagasPagas }})
        </label>
      </div>
      <small class="campo-ajuda">{{ concessaoTexts.manter_pagos_ajuda }}</small>
    </div>

    <div class="field">
      <label>{{ concessaoTexts.motivo }}</label>
      <input pInputText class="w-full" [(ngModel)]="especialMotivo" maxlength="255" />
    </div>
  </div>

  <!-- Rodape em duas linhas: as cobrancas em cima, alinhadas a direita, e a linha de baixo
       fechando o dialogo — Cancelar a esquerda e a acao principal a direita, sempre juntas. -->
  <ng-template pTemplate="footer">
    <div class="dialog-acoes">
      <div class="dialog-acoes__cobrancas">
        <button pButton icon="pi pi-qrcode" class="p-button-outlined"
          [label]="especialTexts.cobrar_qr" [loading]="salvandoEspecial"
          (click)="cobrarPlanoEspecial('QR_VENDAS')"></button>
        <button pButton icon="pi pi-credit-card" class="p-button-outlined"
          [label]="especialTexts.cobrar_cartao" [loading]="salvandoEspecial"
          (click)="cobrarPlanoEspecial('T_PAGO')"></button>
      </div>
      <div class="dialog-acoes__final">
        <button pButton class="p-button-secondary p-button-text"
          [label]="concessaoTexts.cancelar"
          [disabled]="salvandoEspecial" (click)="especialDialogVisible = false"></button>
        <button pButton icon="pi pi-check" [label]="especialTexts.conceder"
          [loading]="salvandoEspecial" (click)="concederPlanoEspecial()"></button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="vagasDialogVisible" [modal]="true" [draggable]="false"
  [header]="concessaoTexts.conceder_vagas" [style]="{ width: '30rem' }">
  <div class="dialog-conteudo">
    <p class="dialog-alvo" *ngIf="resumo?.empresa as empresa">
      {{ concessaoTexts.alvo }}: {{ empresa.nome }}
    </p>
    <p class="dialog-aviso">{{ concessaoTexts.sem_cobranca }}</p>

    <div class="field">
      <label>{{ concessaoTexts.total_acessos }}</label>
      <p-inputNumber [(ngModel)]="vagasUsuariosPermitidos" [min]="minimoDeAcessos" [max]="100"
        [showButtons]="true" styleClass="w-full" inputStyleClass="w-full"></p-inputNumber>
      <small class="campo-ajuda">{{ concessaoTexts.total_acessos_ajuda }}</small>
    </div>

    <div class="field">
      <label>{{ concessaoTexts.motivo }}</label>
      <input pInputText class="w-full" [(ngModel)]="vagasMotivo" maxlength="255" />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" [label]="concessaoTexts.cancelar"
      [disabled]="salvandoVagas" (click)="vagasDialogVisible = false"></button>
    <button pButton icon="pi pi-check" [label]="concessaoTexts.salvar"
      [loading]="salvandoVagas" (click)="concederVagas()"></button>
  </ng-template>
</p-dialog>

<!-- Dialogo: cobranca do cliente (QR ou link da Bancard) -->
<p-dialog [(visible)]="cobrancaDialogVisible" [modal]="true" [draggable]="false"
  [header]="cobrancaTipo === 'ESPECIAL' ? especialTexts.titulo
    : (cobrancaTipo === 'PLANO' ? cobrancaTexts.titulo_plano : cobrancaTexts.titulo_vagas)"
  [style]="{ width: '32rem' }" (onHide)="fecharCobranca()">
  <div class="dialog-conteudo">
    <p class="dialog-alvo" *ngIf="resumo?.empresa as empresa">
      {{ concessaoTexts.alvo }}: {{ empresa.nome }}
    </p>
    <p class="dialog-aviso">{{ cobrancaTexts.explicacao }}</p>

    <!-- Escolha do que cobrar (some depois de gerar) -->
    <ng-container *ngIf="!cobrancaIntencao">
      <div class="field" *ngIf="cobrancaTipo === 'PLANO'">
        <label>{{ concessaoTexts.plano }}</label>
        <p-dropdown [options]="planos" optionLabel="nome" optionValue="id"
          [(ngModel)]="cobrancaPlanoId" [loading]="planosCarregando"
          [filter]="true" filterBy="nome" appendTo="body" styleClass="w-full">
        </p-dropdown>
      </div>

      <div class="field" *ngIf="cobrancaTipo === 'VAGAS'">
        <label>{{ cobrancaTexts.quantidade }}</label>
        <p-inputNumber [(ngModel)]="cobrancaQuantidade" [min]="1" [max]="100"
          [showButtons]="true" (onBlur)="simularVagas()"
          styleClass="w-full" inputStyleClass="w-full"></p-inputNumber>
        <small class="campo-ajuda" *ngIf="cobrancaSimulacao">
          {{ cobrancaTexts.valor }}: {{ cobrancaSimulacao.valorTotal | guaraniFormat }}
        </small>
      </div>

      <div class="acoes-assinatura" *ngIf="cobrancaTipo !== 'ESPECIAL'">
        <button pButton icon="pi pi-qrcode" [label]="cobrancaTexts.gerar_qr"
          [loading]="gerandoCobranca" (click)="gerarCobranca(false)"></button>
        <button pButton icon="pi pi-credit-card" class="p-button-outlined"
          [label]="cobrancaTexts.gerar_link"
          [loading]="gerandoCobranca" (click)="gerarCobranca(true)"></button>
      </div>
    </ng-container>

    <!-- Codigo gerado: o suporte repassa ao cliente -->
    <div class="cobranca-resultado" *ngIf="cobrancaIntencao as intencao">
      <img *ngIf="intencao.urlQr" class="cobranca-qr" [src]="intencao.urlQr" alt="QR Code" />

      <button pButton *ngIf="intencao.qrData" icon="pi pi-copy" class="p-button-text"
        [label]="cobrancaTexts.copiar" (click)="copiarTexto(intencao.qrData)"></button>

      <a *ngIf="intencao.linkUrl" [href]="intencao.linkUrl" target="_blank" rel="noopener"
        class="p-button p-button-outlined cobranca-link">
        <i class="pi pi-external-link mr-2"></i>{{ cobrancaTexts.abrir_link }}
      </a>
      <button pButton *ngIf="intencao.linkUrl" icon="pi pi-copy" class="p-button-text"
        [label]="cobrancaTexts.copiar" (click)="copiarTexto(intencao.linkUrl)"></button>

      <div class="cobranca-status" *ngIf="!cobrancaConfirmada">
        <i class="pi pi-spin pi-spinner"></i>
        <span>{{ cobrancaTexts.aguardando }}</span>
      </div>
      <div class="cobranca-status cobranca-status--ok" *ngIf="cobrancaConfirmada">
        <i class="pi pi-check-circle"></i>
        <span>{{ cobrancaTexts.confirmado }}</span>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" [label]="cobrancaTexts.fechar"
      (click)="fecharCobranca()"></button>
  </ng-template>
</p-dialog>
